<template>
  <div style="height: 100%">
    <h5-list v-if="currentView==='H5List'" />
    <h5-deploy v-if="currentView==='h5Deploy'" />
    <h5-access-code v-if="currentView==='H5AccessCode'" />
  </div>
</template>
<script>
import H5List from './h5List'
import H5Deploy from './h5Deploy'
import H5AccessCode from './h5AccessCode'

export default {
  name: '',
  data() {
    return {
      currentView: 'H5List', // 当前激活的页面
      currentChannelInfoId: '', // 当前选中的配置项id
      accessScriptSrc: ''// 接入代码src
    }
  },
  components: {
    H5List,
    H5Deploy,
    H5AccessCode
  },
  methods: {
    changeView(view) {
      this.currentView = view
    }
  }
}
</script>
